import { createClient } from "contentful";

export const getClient = () => {
  return createClient({
    space: "39id4c0b7dki",
    accessToken: "fRoz9WEspRcCaJL88AXXs1jctIpWmM-PCegnRRQyQOM",
    environment: "master",
    host: "cdn.contentful.com"
  });
};

export default {
  getClient
};
